import { jsx as _jsx } from "react/jsx-runtime";
import { Stepper } from "@opala-ds/react";
import AddressDataForm from "../Forms/AddressDataForm";
import PersonalDataForm from "../Forms/PersonalDataForm";
import SchoolDataForm from "../Forms/SchoolDataForm";
import LegalRepresentativeDataForm from "../Forms/LegalRepresentativeDataForm";
import useAthleteStore from "../../stores/athleteStore";
import TermsAndConditionsAthleteForm from "../Forms/TermsAndConditionsAthleteForm";
import CategoryAndModalityDataForm from "../Forms/CategoryAndModalityDataForm";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useCreateAthlete } from "../../queries/jepis";
export default function AthleteStepper() {
    var personalData = useAthleteStore(function (state) { return state.personalData; });
    var addressData = useAthleteStore(function (state) { return state.addressData; });
    var schoolData = useAthleteStore(function (state) { return state.schoolData; });
    var legalRepresentativeData = useAthleteStore(function (state) { return state.legalRepresentativeData; });
    var categoryAndModalityData = useAthleteStore(function (state) { return state.categoryAndModalityData; });
    var setPersonalData = useAthleteStore(function (state) { return state.setPersonalData; });
    var setAddressData = useAthleteStore(function (state) { return state.setAddressData; });
    var setSchoolData = useAthleteStore(function (state) { return state.setSchoolData; });
    var setLegalRepresentativeData = useAthleteStore(function (state) { return state.setLegalRepresentativeData; });
    var setTermsAndConditionsData = useAthleteStore(function (state) { return state.setTermsAndConditionsData; });
    var setCategoryAndModalityData = useAthleteStore(function (state) { return state.setCategoryAndModalityData; });
    var isMobile = useIsMobile();
    var createAthlete = useCreateAthlete().mutate;
    return (_jsx(Stepper, { showIndicator: !isMobile, initialStep: 0, orientation: "horizontal", steps: [
            {
                title: "Dados Pessoais do Estudante",
                content: (_jsx(PersonalDataForm, { onSubmit: setPersonalData, defaultValues: personalData })),
            },
            {
                title: "Endereço",
                content: (_jsx(AddressDataForm, { onSubmit: setAddressData, defaultValues: addressData })),
            },
            {
                title: "Dados escolares",
                content: (_jsx(SchoolDataForm, { onSubmit: setSchoolData, defaultValues: schoolData })),
            },
            {
                title: "Dados do Responsável Legal",
                content: (_jsx(LegalRepresentativeDataForm, { onSubmit: setLegalRepresentativeData, defaultValues: legalRepresentativeData })),
            },
            {
                title: "Categoria e Modalidade",
                content: (_jsx(CategoryAndModalityDataForm, { onSubmit: setCategoryAndModalityData, defaultValues: categoryAndModalityData })),
            },
            {
                title: "Aceite dos Termos e Condições",
                content: (_jsx(TermsAndConditionsAthleteForm, { onSubmit: function (data) {
                        setTermsAndConditionsData(data);
                        createAthlete({
                            payload: {
                                personalData: personalData,
                                addressData: addressData,
                                schoolData: schoolData,
                                legalRepresentativeData: legalRepresentativeData,
                                categoryAndModalityData: categoryAndModalityData,
                                termsAndConditionsData: data,
                            },
                        });
                    } })),
            },
        ], textAlignment: "center" }));
}
